import { bus } from "@/bus";

const circularMailStatusModule = {
  namespaced: true,
  state: {
    id: 0,
    alreadySend: null
  },
  mutations: {
    update(state, data) {
      bus.$emit("circular-mail-status", {
        id: data.id,
        alreadySend: data.alreadySend
      });
    }
  }
};

export default circularMailStatusModule;
